import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Search from 'flarum/forum/components/Search';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';

import SplitSearchSource from './components/SplitSearchSource';
import SplitSearchExtras from './components/SplitSearchExtras';
import SplitComments from './components/SplitComments';
import isEnabledFor from './isEnabledFor';
import { splitState, resetFor } from './state';

const SORTS = { top: 'popular', newest: 'newest', oldest: 'oldest' };

app.initializers.add('happydigital-split-search', () => {
  const enabled = () => isEnabledFor(app.session.user);

  // Dropdown entry: opens the normal discussion list with the search applied.
  extend(Search.prototype, 'sourceItems', function (items) {
    if (enabled()) items.add('splitSearch', new SplitSearchSource(), 100);
  });

  // Discussion list for a search: title matches only, from our endpoint.
  // Registered after blomstra/search's override, so anything we do not handle
  // falls through to it (and from there to core).
  override(DiscussionListState.prototype, 'loadPage', async function (original, page = 1) {
    const params = this.requestParams();
    const query = params && params.filter && params.filter.q;

    if (!enabled() || !query || String(query).includes(':')) {
      return original.call(this, page);
    }

    // A page loaded from scratch (refresh, shared link) comes with the forum's own
    // search results already embedded; drop them so ours are used instead.
    app.preloadedApiDocument();

    resetFor(query);

    const offset = this.pageSize * (page - 1);
    const payload = await app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/split-search/discussions',
      params: {
        filter: { q: query, sort: SORTS[this.params.sort] || 'latest', range: splitState.range, fuzzy: page > 1 && splitState.fuzzy ? 1 : 0 },
        page: { limit: this.pageSize, offset },
      },
    });

    const meta = payload.meta || {};
    if (page === 1) Object.assign(splitState, { fuzzy: !!meta.fuzzy, suggestion: meta.suggestion || null });

    return app.store.pushPayload(payload);
  });

  // Notice, date filter and matching comments around the discussion list.
  extend(IndexPage.prototype, 'contentItems', function (items) {
    const query = m.route.param('q');

    if (!enabled() || !query || String(query).includes(':')) return;

    items.add('splitSearchExtras', <SplitSearchExtras query={query} />, 95);
    items.add('splitSearchComments', <SplitComments query={query} />, 10);
  });
});
